import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/subAllotments', request)
}

async function put(id, request) {
    return await putMethod(`/api/subAllotments?id=${id}`, request)
}

async function post(body) {
    return await postMethod('/api/subAllotments', body)
}

export {get, put, post}
